import { otaUpdatesUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";

export const createProcessApi = async (
  namespace: string,
  source_id: string,
  body: FormData,
) => {
  const url = otaUpdatesUrlEnvVar();
  const headers = {
    ...buildAxiosAuthenticationHeaders(),
  };

  try {
    const response = await axios.post(
      `${url}/api/v3/ns/${namespace}/firmware-process`,
      body,
      {
        headers,
        params: {
          source_id,
        },
      },
    );

    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      throw err;
    }

    throw err;
  }
};
